import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as value from '../../../../value'
import type * as helpers from '../../../helpers'
import * as outlet from '../outlet'
import * as cellValue from '../value'

/** Chooses the configured component renderer or the standard value renderer. */
@ngCore.Component({
  imports: [
    cellValue.boolean.Component,
    cellValue.enum.Component,
    cellValue.list.Component,
    cellValue.number.Component,
    outlet.Component,
    value.Component,
  ],
  selector: 'atn-ds-table-cell-renderer',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Fully prepared data for the current cell. */
  public readonly cellSg = ngCore.input.required<helpers.Row.Cell>({
    alias: 'cell',
  })

  /**
   * Uses the declared attribute type when available and otherwise infers the
   * intrinsic type from the raw cell value, matching the legacy renderer's
   * default-cell behavior.
   */
  public readonly typeSg = ngCore.computed(
    (cell = this.cellSg()) =>
      cell.valueInfo?.type ??
      ents.core.common.value.types.Intrinsic.inferFrom(cell.value),
  )

  /**
   * Normalizes the raw value to the declared intrinsic type before handing it
   * to a value renderer. DMS projections can return scalar values in a
   * one-element array (for example an INT subquery), while the number renderer
   * correctly accepts only the normalized number.
   */
  public readonly rawValueSg = ngCore.computed(
    (cell = this.cellSg(), type = this.typeSg()) =>
      type ? ents.core.common.value.Raw.cast(cell.value, type) : undefined,
  )

  /** Casts list cells for the legacy list-value presentation. */
  public readonly listValueSg = ngCore.computed(
    (cell = this.cellSg(), type = this.typeSg()) =>
      type === ents.core.common.value.types.Intrinsic.List
        ? ents.core.common.value.Raw.cast(
            cell.value,
            ents.core.common.value.types.Intrinsic.List,
          )
        : undefined,
  )

  /** Declared enum type used by the tag-based enum renderer. */
  public readonly enumSg = ngCore.computed((type = this.typeSg()) =>
    ents.core.common.value.types.Enum.isEnum(type) ? type : undefined,
  )

  /** Intrinsic values exposed to the template's renderer branch. */
  public readonly IntrinsicEnum = ents.core.common.value.types.Intrinsic
}
